import { render, staticRenderFns } from "./Retail.vue?vue&type=template&id=caa3a65a"
import script from "./Retail.vue?vue&type=script&lang=js"
export * from "./Retail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports